import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../Navbar";
import {
  Box,
  Button,
  Container,
  Grid,
  IconButton,
  ListItemIcon,
  MenuItem,
  Tooltip,
  Typography,
} from "@mui/material";
import MaterialReactTable from "material-react-table";
import PersonIcon from "@mui/icons-material/Person";
import { getData } from "../../../services/library";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import MapIcon from "@mui/icons-material/Map";
import AddBoxTwoToneIcon from "@mui/icons-material/AddBoxTwoTone";
import AddHojaRuta from "./alta/AddHojaRuta";
import EditIcon from "@mui/icons-material/Edit";
import EdicionHojaRuta from "./Edicion/EdicionHojaRuta";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { Delete } from "@mui/icons-material";
import BajaHojaRuta from "./baja/BajaHojaRuta";
import MarcarActivoRuta from "./alta/MarcarActivoRuta";

function HojaDeRuta() {
  let navigate = useNavigate();
  const [hojas, setHojas] = useState({});
  const [dataHoja, setDataHoja] = useState();
  const [alta, setAlta] = useState(false);
  const [editar, setEditar] = useState(false);
  const [marcarActivo, setMarcarActivo] = useState(false);
  const [baja, setBaja] = useState(false);
  //Tabla
  const [tabla, setTabla] = useState(true);
  const [hiddenmuestrainactivo, setHiddenmuestrainactivo] = useState(false);
  const [hiddenmuestraactivos, setHiddenmuestraactivos] = useState(true);

  const obtenerHojaInactivas = () => {
    setHiddenmuestrainactivo(true);
    setHiddenmuestraactivos(false);
    getData("/envasado_hoja_ruta/xsucauthinactivos/"+ localStorage.getItem("suc_auth").split(",")+"/"+localStorage.getItem("user"), setHojas);
  };
  const obtenerHojas = (estado) => {
    setHiddenmuestraactivos(true);
    setHiddenmuestrainactivo(false);
    getData("/envasado_hoja_ruta/xsuc/"+ localStorage.getItem("suc_auth").split(","), setHojas);
  };

  useEffect(() => {
    obtenerHojas();
  }, [tabla]);

  const columns = useMemo(
    () => [
      {
        accessorKey: "id", //access nested data with dot notation
        header: "ID",
        maxSize: 20,
      },
      {
        accessorKey: "nombre", //access nested data with dot notation
        header: "Nombre",
        size: 230,
      },
      {
        accessorKey: "descripcion", //access nested data with dot notation
        header: "Descripción",
        size: 180,
      },
      {
        accessorKey: "nombre_sucursal", //access nested data with dot notation
        header: "Sucursal",
        size: 180,
      },
      {
        accessorKey: "patente", //access nested data with dot notation
        header: "Vehiculo",
        size: 180,
      },
      {
        accessorKey: "dias_nombres", //access nested data with dot notation
        header: "Días",
        size: 180,
      },
    ],
    []
  );

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "success",
    size: "small",
  };

  const customLocalization = {
    ...MRT_Localization_ES,
    expandAll: "Ex", // Cambia 'Expandir todo' a 'Ex'
    expand: "Ex", // Cambia 'Expandir' a 'Ex'
  };

  const initialState = {
    density: "compact",
    pagination: { pageIndex: 0, pageSize: 50 },
    showGlobalFilter: true,
    // columnPinning: {
    //   right: ["mrt-row-actions"],
    // },
    grouping: ["nombre_sucursal"],
  };

  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };

  const handleClickNuevo = () => {
    setAlta(true);
  };

  const handleCloseAlta = () => {
    setAlta(false);
    setTabla(true);
    obtenerHojas();
  };

  const handleCloseEditar = () => {
    setEditar(false);
    obtenerHojas();
  };

  return (
    <div>
      <Navbar />

      <Container maxWidth="xl" disableGutters sx={{ mb: 2, mt: 2.5 }}>
        {tabla && (
          <MaterialReactTable
            columns={columns}
            data={hojas ?? [{}]}
            layoutMode={"grid"}
            initialState={initialState}
            enableColumnActions={false}
            enableGlobalFilterModes={true}
            enableHiding={false}
            enableRowActions={true}
            enableGrouping={true}
            enablePinning={true}
            enableColumnFilters={false}
            enableFullScreenToggle={false}
            positionActionsColumn={"last"}
            enableExpandAll={false}
            localization={customLocalization}
            enableToolbarInternalActions={true}
            muiTableHeadCellProps={tableHeadCellProps}
            muiSearchTextFieldProps={muiSearchTextFieldProps}
            enableDensityToggle={false}
            muiTableBodyRowProps={({ row }) => ({
              // onClick: () =>
              //   navigate("/verfacturaenvasado", { state: row.original }),
              sx: {
                cursor: "pointer",
                backgroundColor:
                  row.original.estado === 311
                    ? "rgba(172, 236, 152, 0.3)" // verde más suave
                    : row.original.estado === 328
                    ? "rgba(242, 139, 130, 0.3)" // rojo más suave
                    : null,
                "&:hover": {
                  backgroundColor: "rgba(0, 0, 0, 0.04)", // hover suave
                },
              },
            })}
            enableColumnResizing={true}
            muiTableBodyCellProps={({ row }) => ({
          align: "left",
          sx: {
            backgroundColor: row.original.activo === 1 ? "#b3e6b3" : "#efc3c3",
            color: "black",
            // borderColor: "black",
          },
        })}
            muiTableDetailPanelProps={{
              sx: {
                backgroundColor: "white",
                width: "100%",
              },
            }}
            renderToolbarInternalActions={() => (
              <>
                {!hiddenmuestrainactivo ? (
                  <Tooltip title="Muestra Inactivos">
                    <IconButton
                      onClick={() => obtenerHojaInactivas()}
                      color="error"
                    >
                      <PersonOffIcon />
                    </IconButton>
                  </Tooltip>
                ) : null}
                {!hiddenmuestraactivos ? (
                  <Tooltip title="Mostrar ACTIVOS" color="success">
                    <IconButton onClick={() => obtenerHojas()}>
                      <PersonIcon />
                    </IconButton>
                  </Tooltip>
                ) : null}
              </>
            )}
            renderTopToolbarCustomActions={() => (
              <>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<AddBoxTwoToneIcon color="asd" />}
                  onClick={handleClickNuevo}
                >
                  Nueva Hoja de Ruta
                </Button>

                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <MapIcon sx={{ fontSize: 20 }} />
                  <Typography variant="h6" component="div">
                    Hojas de Ruta
                  </Typography>
                </Box>
              </>
            )}
            renderRowActionMenuItems={({ closeMenu, row }) => [
  <MenuItem
    key={`marcar-activo-${row.original.id}`}
    style={{
      display: row.original.activo === 0 ? null : "none",
    }}
    disabled={row.original.activo === 1}
    onClick={() => {
      setMarcarActivo(true);
      setDataHoja(row.original);
      closeMenu();
    }}
    sx={{ m: 0 }}
  >
    <ListItemIcon>
      <CheckCircleOutlineIcon color="success" />
    </ListItemIcon>
    Marcar Activo
  </MenuItem>,
  <MenuItem
    key={`marcar-inactivo-${row.original.id}`}
    style={{
      display: row.original.activo === 0 ? "none" : null,
    }}
    disabled={row.original.activo === 0}
    onClick={() => {
      closeMenu();
      setDataHoja(row.original);
      setBaja(true);
    }}
    sx={{ m: 0 }}
  >
    <ListItemIcon>
      <Delete color="error" />
    </ListItemIcon>
    Marcar Inactivo
  </MenuItem>,
  <MenuItem
    key={`clientes-${row.original.id}`}
    onClick={() => {
      closeMenu();
      navigate("/envasadoclientesruta", { state: row.original });
    }}
    sx={{ m: 0 }}
  >
    <ListItemIcon>
      <PersonIcon color="success" />
    </ListItemIcon>
    Clientes Adheridos
  </MenuItem>,
  <MenuItem
    key={`editar-${row.original.id}`}
    onClick={() => {
      closeMenu();
      setDataHoja(row.original);
      setEditar(true);
    }}
    sx={{ m: 0 }}
  >
    <ListItemIcon>
      <EditIcon color="primary" />
    </ListItemIcon>
    Editar
  </MenuItem>,
]}
          />
        )}
        {alta ? (
          <AddHojaRuta alta={alta} onClose={() => handleCloseAlta(false)} />
        ) : null}

        {editar ? (
          <EdicionHojaRuta
            editar={editar}
            datosRow={dataHoja}
            onClose={() => handleCloseEditar(false)}
          />
        ) : null}
        {marcarActivo ? (
          <MarcarActivoRuta
            open={marcarActivo}
            setOpen={setMarcarActivo}
            hoja={dataHoja}
            tabla={setTabla}
            actualizar={obtenerHojas}
          />
        ) : null}

        {baja && (
          <BajaHojaRuta
            open={baja}
            setOpen={setBaja}
            hoja={dataHoja}
            tabla={setTabla}
            actualizar={obtenerHojas}
          />
        )}
      </Container>
    </div>
  );
}

export default HojaDeRuta;
